export const headerContainer = {
  height: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  textTransform: "uppercase",
};

export const headerContent = {
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "center",
};

export const backButton = {
  display: "flex",
  alignItems: "center",
  gap: "20px",
};

export const appLogo = {
  height: "24px",
};
export const productFamilyLogo = {
  height: "14px",
};

export const separator = {
  borderRight: "solid 1px",
  borderColor: "grey7",
  height: "30px",
};
export const separator2 = {
  borderRight: "solid 1px",
  borderColor: "grey3",
  height: "30px",
  marginRight: "15px",
  marginLeft: "-10px",
};
export const forwardSlashSeparator = {
  marginLeft: "-10px",
  marginRight: "-10px",
};

export const closeButton = () => ({
  display: "flex",
  alignItems: "center",
  svg: {
    width: "20px",
  },

  "&:hover, &:focus": {
    color: "primary",
  },
});
